import React from "react";
import BlogDetails from './../../../Components/Blog/BlogInner/BlogDetails/blogDetails';
const BlogInner = () => {
  return (<BlogDetails/>);
};

export default BlogInner;
